import AOS from 'aos';

jQuery(document).ready(function( $ ) {

    // Initialize AOS animations
    AOS.init({ duration: 1000 });

    // Navigation
    $('.navbar-toggler').on('click', function () {
        let animatedIcon = $('.animated-icon');
        animatedIcon.toggleClass('open');

        if ($(window).width() <= 920) {
            if (animatedIcon.hasClass('open')) {
                $('body').css('position', 'fixed');
            } else {
                $('body').css('position', 'initial');
            }
        }
    })

    $(".menu-item").click(function() {
        $(".navbar-toggler").click();
    })

    $(".card-header").click(function() {
        let clickedElement = $(this);
        clickedElement.find("button").toggleClass("minus");

        $(".card-header").each(function() {
            if (!$(this).is(clickedElement)) {
                $(this).find("button").removeClass("minus");
            }
        })
    })

    // Set process lines position
    if ($(window).width() >= 768) {
        $(".processItemWrapper").each(function() {
            let wrapperHeight = $(this).outerHeight();
            let textHeight = $(this).find(".processText").outerHeight(true);
            if (!$(this).hasClass("up")) {
                $(this).find(".line").css("top", (wrapperHeight - textHeight) + "px");
            } else {
                $(this).find(".line").css("bottom", (wrapperHeight - textHeight) + "px");
            }
        })
    }

    // Info Popup
    // let infoPopup = new Popup({
    //     id: "info-popup",
    //     title: "Alle 1.500 Startplätze sind belegt!",
    //     content: `
    //         Wir freuen uns sehr über die überwältigende Resonanz zum 2. SPÄH Business RUN!<br>
    //         Leider können wir keine weiteren Startplätze anbieten, es ist dennoch jede/r herzlich eingeladen, die Läufer/innen am 11. Juli entlang der Strecke anzufeuern und im Anschluss mit uns auf dem Festplatz die After-Work-Party bei leckerem Essen und erfrischenden Getränken zu feiern.<br>
    //         Wer die diesjährigen Organisationen, an welche unsere Spende geht, über den #spaehrun hinaus unterstützen möchte, findet über die Homepages die Spendenkonten.<br>
    //         <a href="https://hilfefuerbehinderte.de" target="_blank" title="Hilfe für Menschen mit Behinderung e. V.">Hilfe für Menschen mit Behinderung e. V.</a>
    //         <a href="https://www.frauen-begegnungs-zentrum.de" target="_blank" title="Frauenbegegnungszentrum e. V.">Frauenbegegnungszentrum e. V.</a>
    //     `,
    //     showImmediately: true,
    //     showOnce: false,
    //     backgroundColor: "#004d9e",
    //     titleColor: "#ffffff",
    //     textColor: "#ffffff",
    //     borderRadius: "0",
    //     font: "DINOT"
    // })
});